export default class Colours {
  public static getRandomColors(noOfColors: number) {
    const colours: string[] = [];
    for (let i = 0; i < noOfColors; i++) {
      colours.push(`#${Math.floor(Math.random() * 16777215).toString(16)}`);
    }
    return colours;
  }

  public static getColours(numberOfColours: number) {
    const colours = [
      "#00ffff",
      "#800080",
      "#ff0000",
      "#000000",
      "#0000ff",
      "#a52a2a",
      "#a9a9a9",
      "#006400",
      "#bdb76b",
      "#8b008b",
      "#556b2f",
      "#ff8c00",
      "#9932cc",
      "#e9967a",
      "#9400d3",
      "#ff00ff",
      "#ffd700",
      "#008000",
      "#4b0082",
      "#f0e68c",
      "#00ff00",
      "#ff00ff",
      "#800000",
      "#000080",
      "#808000",
      "#ffa500",
      "#ffc0cb",
      "#800080",
      "#00008b",
      "#008b8b",
      "#c0c0c0",
      "#ffff00",
      "#f0ffff",
      "#8b0000",
      "#add8e6",
      "#e0ffff",
      "#90ee90",
      "#d3d3d3",
      "#ffb6c1",
      "#ffffe0",
      "#00ffff",
      "#f5f5dc",
    ];
    return numberOfColours < colours.length ? colours.slice(0, numberOfColours) : this.getRandomColors(numberOfColours);
  }
}
